import { Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { ExpectedFileColumn } from "../../../app/models/requestModels/fileExpectedColumn";
import SelectedFileModal from "./SelectedFileModal";
import SelectionModal from "./selectionModal";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface FileSelectionArgs {
  onCompleted?: CallableFunction;
  closeFileUploadModal: CallableFunction;
  expectedColumns: ExpectedFileColumn[];
  asyncSubmitOperation: any;
  sampleFileName: string;
  acceptNumberAsZero?: boolean;
  acceptPercentageAsZero?: boolean;
}

const FileUploadModal = ({
  onCompleted,
  closeFileUploadModal,
  expectedColumns,
  asyncSubmitOperation,
  sampleFileName,
  acceptNumberAsZero = false,
  acceptPercentageAsZero = false,
}: FileSelectionArgs) => {
  const [openFileUploadModal, setOpenFileUploadModal] = useState(true);
  const [openFileSelectionModal, setOpenFileSelectionModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleClick = (fileName: string) => {
    const filePath = process.env.PUBLIC_URL + `/sampleFiles/${fileName}`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAsyncSubmit = () => {
    setOpenFileSelectionModal(true);
  };

  const handleModalClose = (val: boolean) => {
    setOpenFileUploadModal(val);
    closeFileUploadModal();
  };

  return (
    <>
      <SelectionModal
        open={openFileUploadModal}
        onClose={handleModalClose}
        title={"File Selection"}
        asyncOperation={handleAsyncSubmit}
        disableSubmit={!selectedFile}
        showCancelOption={true}
        children={
          <Grid
            container
            rowSpacing={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Button
                variant="contained"
                onClick={() => handleClick(sampleFileName)}
              >
                Download Template
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
              >
                Upload
                <input
                  type="file"
                  id="fileInput"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={(event) => {
                    if (
                      !event.target.files ||
                      event.target.files.length === 0
                    ) {
                      return;
                    }
                    if (event.target.files && event.target.files.length > 0) {
                      setSelectedFile(event.target.files[0]);
                      event.target.value = "";
                    }
                  }}
                  hidden
                />
              </Button>
            </Grid>
            {selectedFile && (
              <Typography m={1} variant="subtitle2" component="p">
                Selected file: {selectedFile.name}
              </Typography>
            )}
          </Grid>
        }
      />
      {openFileSelectionModal && (
        <SelectedFileModal
          closeSelectedFileModal={closeFileUploadModal}
          selectedFile={selectedFile}
          expectedColumns={expectedColumns}
          asyncSubmitOperation={asyncSubmitOperation}
          onCompleted={onCompleted}
          acceptNumberAsZero={acceptNumberAsZero}
          acceptPercentageAsZero={acceptPercentageAsZero}
        />
      )}
    </>
  );
};
export default FileUploadModal;
